export enum EDroneActionEvent {
  DAE_None,
  DAE_BeginDocking,
  DAE_UpdateQueuePosition,
  DAE_ReachedDestination,
  DAE_NotifyPairedStationUpdate,
}
